import { ExternalLink } from "lucide-react";
import { useTranslation } from "react-i18next";
import { SectionShell } from "./SectionShell";

type LinkItem = {
  name: string;
  descJa: string;
  descEn: string;
  url: string;
};

// これまで当サイトに未掲載の外部AI関連リンク（補助金は別枠のため含めない）。自社サイトLabsは末尾。
const links: LinkItem[] = [
  {
    name: "経済産業省｜AI事業者ガイドライン",
    descJa: "AIの開発・提供・利用に関する国のガイドライン",
    descEn: "Japan's national guidelines for AI operators (METI / MIC)",
    url: "https://www.meti.go.jp/shingikai/mono_info_service/ai_shakai_jisso/20260331_report.html",
  },
  {
    name: "デジタル庁｜生成AI調達・利活用ガイドライン",
    descJa: "行政における生成AIの調達と安全な利活用に関するガイドライン",
    descEn: "Guidelines for safe procurement and use of generative AI in government",
    url: "https://www.digital.go.jp/news/decb64eb-f26e-41cb-8d37-f3dd173108b8",
  },
  {
    name: "IPA 情報処理推進機構",
    descJa: "AI・DX・情報セキュリティに関する国の推進機関（経産省所管）",
    descEn: "Information-technology Promotion Agency for AI / DX (under METI)",
    url: "https://www.ipa.go.jp/",
  },
  {
    name: "Anthropic News",
    descJa: "Claude を開発する Anthropic の公式ニュース・リリース",
    descEn: "Official news and releases from Anthropic (makers of Claude)",
    url: "https://www.anthropic.com/news",
  },
  {
    name: "OpenAI News",
    descJa: "ChatGPT を開発する OpenAI の公式ニュース・リリース",
    descEn: "Official news and releases from OpenAI (makers of ChatGPT)",
    url: "https://openai.com/news/",
  },
  {
    name: "AI Labs（PLANNINGJOY プロダクトサイト）",
    descJa: "PLANNINGJOY が自社開発する AI プロダクトの紹介サイト",
    descEn: "Showcase of the AI products PLANNINGJOY builds in-house",
    url: "https://labs.planjoy.net/",
  },
];

/**
 * お役立ちリンク。
 * 見出しはオーナー指示（2026-09-10）で「AI関連リンク」から改めた。リンクと説明文は元のまま。
 */
export const AiLinksSection = () => {
  const { i18n } = useTranslation();
  const isJa = i18n.language.startsWith("ja");

  return (
    <SectionShell
      id="resources"
      icon={<ExternalLink aria-hidden="true" focusable="false" />}
      heading={isJa ? "お役立ちリンク" : "Useful Links"}
      photo={{ src: "/images/home/topics.jpg" }}
    >
      <p className="plan-intro" data-reveal>
        {isJa
          ? "経済産業省系のAI関連情報、主要AIベンダーの最新ニュース、当社のAIプロダクトサイトへのリンクです。"
          : "Links to METI-related AI information, the latest news from leading AI vendors, and our own AI product site."}
      </p>
      <div className="resource-grid">
        {links.map((item) => (
          <a
            className="resource"
            key={item.url}
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            data-reveal
          >
            <ExternalLink aria-hidden="true" focusable="false" />
            <h3>{item.name}</h3>
            <p>{isJa ? item.descJa : item.descEn}</p>
          </a>
        ))}
      </div>
    </SectionShell>
  );
};
